import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=386b5952&scoped=true"
import script from "./videoDialog.vue?vue&type=script&lang=js"
export * from "./videoDialog.vue?vue&type=script&lang=js"
import style0 from "./videoDialog.vue?vue&type=style&index=0&id=386b5952&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b5952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386b5952')) {
      api.createRecord('386b5952', component.options)
    } else {
      api.reload('386b5952', component.options)
    }
    module.hot.accept("./videoDialog.vue?vue&type=template&id=386b5952&scoped=true", function () {
      api.rerender('386b5952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/videoDialog.vue"
export default component.exports